import { useField } from 'formik';
import { FormikDatepicker } from '@spotted-zebra-uk/ui-components';
import styles from './ProjectFilterModal.module.scss';

const dateRangeSections = [
  { title: 'Date created', fieldNamePrefix: 'dateCreated' },
  { title: 'Date published', fieldNamePrefix: 'datePublished' },
  { title: 'Date last edited', fieldNamePrefix: 'dateLastEdited' },
];

const DatesTabContent = () => (
  <>
    {dateRangeSections.map(dateRangeSection => (
      <div className={styles.section} key={dateRangeSection.fieldNamePrefix}>
        <p className={styles.dateFieldsTitle}>{dateRangeSection.title}</p>
        <div className={styles.fieldsRow}>
          <FormikDatepicker
            id={`${dateRangeSection.fieldNamePrefix}From`}
            label="From"
            bottomText="dd/mm/yyyy"
            useFormikField={useField}
          />
          <FormikDatepicker
            id={`${dateRangeSection.fieldNamePrefix}To`}
            label="To"
            bottomText="dd/mm/yyyy"
            useFormikField={useField}
          />
        </div>
      </div>
    ))}
  </>
);

export default DatesTabContent;
